import React, { Component } from 'react';
import { connect } from 'react-redux';
import WorkSessionsTable from '../components/views/WorkSessionsTable';
import { withRouter } from '../helpers/withRouter';
import {
  closeModal, openModal
} from '../redux/actions';
import { fetchWorkSessionsTable } from '../redux/actions/work-sessions';
import type { SingleModalState, State, User } from '../types';

interface WorkSessionsContainerProps {
  currentUser: User;
  router: any;
  users: Array<User>;
  workSessionsByUser: { [userId: number]: Array<any> };
  statisticsByUser: Array<{ id: number, onSiteCount: number, requiredSiteCount: number }>;
  statisticsByDay: Array<{ date: string, onSiteCount: number }>;
  lateStatisticsByUser: Array<{ id: number, lateCount: number }>;
  fetchWorkSessionsTable: (startDate: string, endDate: string) => Promise<any>;
  isLoading: boolean;
  openModal: Function,
  closeModal: Function,
}

interface WorkSessionsContainerState {
  startDate: string;
  endDate: string;
}

class WorkSessions extends Component<WorkSessionsContainerProps, WorkSessionsContainerState> {
  state = {
    startDate: '',
    endDate: '',
  };

  handleStartDateChange = (date: string) => {
    this.setState({ startDate: date });
  };

  handleEndDateChange = (date: string) => {
    this.setState({ endDate: date });
  };

  handleSubmitFetch = () => {
    const { startDate, endDate } = this.state;

    if (startDate && endDate) {
      this.props.fetchWorkSessionsTable(startDate, endDate);
    }
  };

  render(): React.ReactNode {
    return (
      <WorkSessionsTable
        {...this.props}

        startDate={this.state.startDate}
        endDate={this.state.endDate}
        onStartDateChange={this.handleStartDateChange}
        onEndDateChange={this.handleEndDateChange}
        onSubmitFetch={this.handleSubmitFetch}
      />
    );
  }
}

const mapStateToProps = (state: State) => ({
  currentUser: state.currentUser,
  users: state.workSessions.tableUsers || [],
  workSessionsByUser: state.workSessions.tableSessionsByUser || {},
  statisticsByUser: state.workSessions.tableStatisticsByUser || [],
  statisticsByDay: state.workSessions.tableStatisticsByDay || [],
  lateStatisticsByUser: state.workSessions.tableLateStatisticsByUser || [],
  isLoading: state.workSessions.tableLoading || false,
});

const mapDispatchToProps = (dispatch: any) => ({
  fetchWorkSessionsTable: (startDate: string, endDate: string) =>
    dispatch(fetchWorkSessionsTable(startDate, endDate)),
  openModal: (modal: SingleModalState) => dispatch(openModal(modal)),
  closeModal: (modal: SingleModalState) => dispatch(closeModal(modal)),
});

const ConnectedWorkSessions = withRouter(connect(mapStateToProps, mapDispatchToProps)(WorkSessions as any));

export default ConnectedWorkSessions;